"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RatingMysqlHandler", {
    enumerable: true,
    get: function() {
        return RatingMysqlHandler;
    }
});
const _ratinggeneralhandler = require("./rating.general.handler");
const _decimalmysqlhandler = require("~/db/field-handler/handlers/decimal/decimal.mysql.handler");
let RatingMysqlHandler = class RatingMysqlHandler extends _decimalmysqlhandler.DecimalMysqlHandler {
    constructor(...args){
        super(...args), this.ratingGeneralHandler = new _ratinggeneralhandler.RatingGeneralHandler(), this.parseUserInput = this.ratingGeneralHandler.parseUserInput, this.filterLt = this.ratingGeneralHandler.filterLt, this.filterLte = this.ratingGeneralHandler.filterLte, this.filterGte = this.ratingGeneralHandler.filterGte;
    }
};
